import React from "react";
// import * as reportStyles from "../../../ReportPage/Reportstyle.module.css";
import reportStyles from "../../../ReportPage/Reportstyle.module.css";
import { useIntl } from "react-intl";

const PerformanceFocusCard = (props) => {
  const intl = useIntl();
  const { mainTitle = "", data } = props;

  return (
    <>
      <div class={reportStyles.divbackground6}>
        {/* Table heading */}
        <h3 class={reportStyles.heading1}>{mainTitle}</h3>

        {/* Table */}
        <div className="table-responsive-sm">
          <table className="table table-borderless">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>#</th>
                <th style={{ width: "30%" }}>
                  {intl.formatMessage({ id: "name" })}
                </th>
                <th style={{ width: "20%" }} className="text-center">
                  {intl.formatMessage({ id: "focus" })}
                </th>
                <th style={{ width: "20%" }} className="text-center">
                  {intl.formatMessage({ id: "average" })}
                </th>
                <th style={{ width: "20%" }} className="text-center">
                  {intl.formatMessage({ id: "count" })}
                </th>
              </tr>
            </thead>

            <tbody>
              {data.length
                ? data.map((item, i) => (
                    <tr
                      style={{
                        background: i % 2 !== 0 ? "#f4f4f4" : "",
                      }}
                    >
                      <td className="font-weight-bold">{i + 1}</td>
                      <td>{item.name}</td>
                      <td className="text-center">{item.focus}</td>
                      <td className="text-center">
                        {parseFloat(item.average).toFixed(1)} %
                      </td>
                      <td className="text-center">{item.count}</td>
                    </tr>
                  ))
                : ""}
            </tbody>
          </table>
        </div>
      </div>

      <div class={reportStyles.divbackground5}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              paddingRight: "10px",
            }}
          >
            <i
              class={`fa-regular fa-lightbulb ${reportStyles.iconGrid}`}
              style={{ color: props.color }}
            ></i>
          </div>
          <div>
            <h3 class={reportStyles.heading2}>
              {intl.formatMessage({ id: "did-you-know" })}
            </h3>

            <p class={reportStyles.para2}>
              <span>
                {intl.formatMessage({ id: "net-promoter-score-info" })}
              </span>{" "}
              {
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a href="#" style={{ color: props.color }}>
                  {intl.formatMessage({ id: "link" })}
                </a>
              }
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PerformanceFocusCard;
